import {call, put, select, takeEvery} from 'redux-saga/effects';
import {push} from 'react-router-redux'
import {getAccountToken} from '../selectors';
import {CALL_API, CALL_API_COMPLETE, showMessage} from '../actions';
import {getApiUrl} from '../config'
import {beginTask, endTask} from 'redux-nprogress'
import map from 'lodash/map'

function* callApi(action) {

    // It is not a api saga
    if( ! action.types ) return;

    try
    {
        if (action.quiet !== true) {
            yield put({type: action.types[0], payload: action.payload});
            yield put(beginTask());
        }

        //const authenticated = yield select(getAuthenticated);
        const token = yield select(getAccountToken);

        const method = action.method ? action.method.toUpperCase() : "GET";


        var headers = {
            'Authorization': 'Bearer ' + token,
            'Accept': 'application/json, application/xml, text/plain, text/html, *.*',
        };

        var body = undefined;
        const hasFormData = action.payload && action.payload.formData;
        if((method === "POST" || method === "PUT") && action.payload) {
            if(hasFormData) {
                body = action.payload.formData
            }
            else
            {
                body = action.payload && JSON.stringify(action.payload);
                headers = {
                    ...headers,
                    'Content-Type': 'application/json'
                }
            }
        }

        const fetchOptions = {
            method: method,
            headers: headers,
            body: body
        };

        const response = yield call(fetch, getApiUrl() + action.path, fetchOptions);

        const data = yield response.json();

        if (response.status >= 200 && response.status < 300)
        {
            yield put({type: action.types[1], payload: {
                    ...data,
                    original: action.payload
                }
            });

            if(action.message)
                yield put(showMessage('info', action.message));

            if(action.redirect)
                yield put(push(typeof action.redirect === "function" ? action.redirect(data) : action.redirect))
        }
        else {
            yield put({type: action.types[2], payload: {error: data, original: action.payload}});
            if(data.errors)
            {
                yield put(showMessage('error', data.message + ':\r\n' + map(data.errors, x => x.message).join('\r\n') ))
            }
            else
                yield put(showMessage('error', data.message ))
        }

    }
    catch (error)
    {
        console.error(error);
        yield put({type: action.types[2], payload: {error: error, original: action.payload}});
        yield put(showMessage('error', error.message))
    }
    finally {
        yield put({type: CALL_API_COMPLETE});
        if (action.quiet !== true) {
            yield put(endTask());
        }
    }
}

export default function* AccountSaga() {
    yield takeEvery(CALL_API, callApi);
};


// WEBPACK FOOTER //
// ./src/saga/apiSaga.js